export default __webpack_public_path__ + "static/tutor-screen-bd5eb43868b7bdc19bf151920c10910e.png";